module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Sort#2-6b795d4653b78ef5aec6c03e5a581d6d.svg";